export default "__VITE_ASSET__7b8e6c86__"